<template>
  <span
    class="Delta"
    :class="{
      'green' : x > 0,
      'grey'  : x == 0,
      'red'   : x < 0
    }"
  >
    <template v-if="showNumber">
      <span v-if="x > 0">+</span>{{ x }}
    </template>

    <template v-else>
      <i class="fas fa-angle-up" v-if="x > 0"></i>
      <strong v-if="x == 0">-</strong>
      <i class="fas fa-angle-down" v-if="x < 0"></i>
    </template>
  </span>
</template>

<script>
  export default {
    props: {
      x: {
        type: Number,
        default: 0
      },

      showNumber: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="scss">
</style>